// ***********************************
// Testing.vue
// November 2024 - page to run test cases
// ***********************************
<template>
  <div id="app">
    <div class="container">
      

      
      <b-form  @reset="onReset">

        <b-card
          no-body
          class="mb-1"
          border-variant="primary"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            DBCSI Testcase Runner
          </b-card-header>

            <b-card-body>


              <b-form-group label="Test Cases:" label-cols="3" label-size="sm">

                <b-form-select v-model="testcaseSelected" size="sm" :options="tests_lov"/>

              </b-form-group>

              <div>
                <b-button
                  v-on:click="runTestCase"
                  type="button"
                  v-b-tooltip.hover
                  title="Run selected testcase."
                  block
                  variant="outline-primary"
                >Run selected testcase as user xxxxx.</b-button>
                <br>
              </div>
              
              <div>
              <b-alert :show="showAlertRecalc" :variant="alertStyleRecalc">{{alertTextRecalc}}</b-alert>
              <b-alert :show="showCalculateMessageFlag" variant="danger">Please click on one of the above buttons.</b-alert>
                

 
              </div>
              

            </b-card-body>

        </b-card>
      </b-form>
    </div>
  </div>
</template>

<script>
import { Auth, API } from "aws-amplify";
import axios from "axios";

export default {
  name: "app",
  data() {
    return {
      user: '',
      showAlert: false,
      alertText: "",
      alertStyle: "default",
      alertTextRecalc: "",
      alertStyleRecalc: "default",
      showAlertRecalc: true,
      showCalculateMessageFlag: false,
      testcaseSelected: "test1",
      tests_lov: [
{ value: 'test1', text: 'GET /shape_attributes/us-east-1/AmazonEC2/r6i.xlarge' },
{ value: 'test2', text: 'GET /adhoc_chart_columns/459' },
{ value: 'test3', text: 'GET /459-all/ora_v1/cpu_per_s' }
]
   
    };
  },
    async created() {    
    
    let name = await Auth.currentAuthenticatedUser();
    this.user = name.username;
    // console.log("authenticated", this.user, name);
    //if we need email, it can be found at name.attributes.email
    
    if ( (!["dbayardAWS","amzn~dbayard"].includes(this.user)) ) {
            console.log("Sorry, not authorized to view this page.  Routing back to main page.");      
            this.$router.push('/');
    }        

    },
  methods: {

    async runTestCase(evt, mode) {
      console.log("Running Test Case");
      evt.preventDefault();
      this.showCalculateMessageFlag = false;
      this.alertStyleRecalc="primary";
      this.alertTextRecalc = "Running Test Case... Please wait...";
      this.showAlertRecalc = true;

      //load test case JSON
      //create request
      //send request
      //compare response
      
     var testcase={};
     await axios
      .get("/tests/"+this.testcaseSelected+".json")
      .then(response => {
        console.log("Loading "+this.testcaseSelected+".json", response.data.test);
        testcase = response.data.test;

      })
      .catch(error => {
        console.log("Testing-Load test case Error:", error);
      });


     var isSuccess = true;
     var tries = 5;
     // var newShapes = JSON.parse(JSON.stringify(myRdsItems));
     
         
         
        this.alertTextRecalc = "Running Test Case for "+testcase.name+ " [ "+ testcase.path + " ]";

        // due to throttling and timeouts, use a loop and multiple tries
        
        tries =2;
        
        while (tries > 0) {
          isSuccess = true;
          
            await API.get(
              "dbcsiAPI",
              testcase.path,
              {queryStringParameters: {
                  dbcsiCaching: 'false'
                } }
            )
              .then(response => {
      				 	console.log("response "+response);
      					if (response.success) {
      					  console.log("get data ",response.data);
      					  
      					  if (JSON.stringify(response.data) == JSON.stringify(testcase.response)) {
      					    console.log("it is a match");
      					    this.alertTextRecalc = "Running Test Case Finished.  Response matches";
                    this.alertStyleRecalc="success";
      					  } else {
      					    isSuccess = false;
      					    console.log("NO MATCH");
      					    console.log("Expected response for "+testcase.path, JSON.stringify(testcase.response));
                    console.log("Actual response", JSON.stringify(response.data));
                    this.alertTextRecalc = "Running Test Case Finished.  Results do not match.";
                    this.alertStyleRecalc="warning";
      					    
      					  }   
      					 
    
      					} else {
    					    console.log("Testcase Error:", testcase.name);
    					    isSuccess = false;
    					  }
                
              })
              .catch(error => {
                console.log("Testcase Error:", testcase.name, error);
                isSuccess = false;
                
              });  
          

            if (isSuccess) {
              break;
            } else {
              tries--;
              console.log("Retrying. Tries remaining", tries);
            }
         
          } //end while




         
           
       
     
          

     
     
     
    },
    


    onReset(evt) {
      evt.preventDefault();
    }
  }
};
</script>

<style>
</style>
